import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrap-top" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "top-list" }
const _hoisted_4 = { class: "home" }

import { ref, onMounted } from "vue";
import IndexPc from "@/components/pc/IndexPc.vue";
import IndexMobile from "@/components/mobile/IndexMobile.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const componentStatus = ref(false);

const isMobile = () => {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  if (flag) {
    componentStatus.value = true;
  } else {
    componentStatus.value = false;
  }
};

onMounted(() => {
  isMobile();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(componentStatus.value ? IndexMobile : IndexPc)))
        ])
      ])
    ])
  ]))
}
}

})